import Button from "@/shared/form/button";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import Drawer from "@/shared/feedback/drawer";
import { ReactNode, useEffect, useState } from "react";
import { useLayoutVars } from "../../vars/vars";
import { Logo } from "@/modules/common/widgets/logo";
import { MobileMenu as MobileMenuItems } from "@/modules/common/widgets/navigation";
import { useLocation } from "react-router-dom";

export function MobileMenu() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const close = () => setIsOpen(false);

  useEffect(() => {
    close();
  }, [location]);

  return (
    <>
      <Button
        type="text"
        shape="circle"
        size="large"
        icon={<MenuOutlined className="!text-2xl" />}
        onClick={() => setIsOpen(true)}
      />
      <Drawer
        open={isOpen}
        onClose={close}
        placement="left"
        key="left"
        closable={false}
        width={258}
        className="[&_.ant-drawer-body]:!p-0"
      >
        <Head>
          <Logo />
          <Button
            icon={<CloseOutlined />}
            onClick={close}
            type="text"
            className="!text-3xl"
            size="large"
          />
        </Head>
        <div>
          <MobileMenuItems />
        </div>
      </Drawer>
    </>
  );
}

function Head({ children }: { children: ReactNode }) {
  const vars = useLayoutVars();

  return (
    <div
      style={vars}
      className="min-h-[var(--header-height)] px-6 flex items-center justify-between shadow-sm"
    >
      {children}
    </div>
  );
}
